// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2-MCL","log":"ModalInventoryLogs_log__1ENs7","date":"ModalInventoryLogs_date__t2ASP","userName":"ModalInventoryLogs_userName__3IPuI"};